<template>
  <div>
    <v-data-table
      v-if="users"
      :headers="headers"
      :items="users.edges"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("admin.users.users") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="
              createUserDialog = true;
              newItem = {};
            "
          >
            {{ $t("forms.create") }}
          </v-btn>
          <v-dialog v-model="createUserDialog" :key="'create' + editedItem.id">
            <CreateDialog
              :availableRoles="availableRoles"
              @dialog="createUserDialog = $event"
            />
          </v-dialog>
          <v-dialog v-model="dialog" :key="'editRoles' + editedItem.id">
            <EditDialog
              :editedItem="editedItem"
              @roles="editedItem.roles = $event"
              @email="editedItem.email = $event"
              :availableRoles="availableRoles"
              @dialog="dialog = $event"
              @reset="reset"
            />
          </v-dialog>
          <v-dialog v-model="editNameDialog" :key="'editName' + editedItem.id">
            <EditNameDialog
              :editedItem="editedItem"
              @roles="editedItem.roles = $event"
              @email="editedItem.email = $event"
              :availableRoles="availableRoles"
              @dialog="editNameDialog = $event"
              @reset="resetEditNameDialog"
            />
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.node.userProfile.firstName`]="{ item }">
        <div v-if="item.node.userProfile">
        {{ item.node.userProfile.firstName}}
        {{ item.node.userProfile.lastName}}
        <v-icon small class="mr-2" @click="editName(item)"> mdi-pencil </v-icon>
        </div>
      </template>
      <template v-slot:[`item.node.roles`]="{ item }">
        <div v-for="role in item.node.roles" :key="role.id">
          {{ role }}
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import gql from "graphql-tag";
import CreateDialog from "./CreateDialog.vue";
import EditDialog from "./EditDialog.vue";
import EditNameDialog from "./EditNameDialog.vue";
export default {
  components: {
    CreateDialog,
    EditDialog,
    EditNameDialog,
  },
  apollo: {
    users: {
      query: gql`
        query GetUsers {
          users (first: 1000){
            edges {
              node {
                id
                roles
                email
                eulaAgreed
                userProfile {
                  id
                  firstName
                  lastName
                  username
                }
              }
            }
          }
        }
      `,
    },
    availableRoles: {
      query: gql`
        query {
          roles {
            id
            _id
          }
        }
      `,
      update(data) {
        return data.roles.map((role) => role._id);
      },
    },
  },
  data() {
    return {
      dialog: false,
      editNameDialog: false,
      createUserDialog: false,
      selectedRoles: [],
      editedItem: { userProfile: {} },
      newItem: {},
      formTitle: "Edit User",
      headers: [
        { text: this.$t("admin.id"), value: "node.id" },
        { text: this.$t("login.email"), value: "node.email" },
        { text: this.$t("admin.users.roles"), value: "node.roles" },
        { text: "name", value: "node.userProfile.firstName" },
        { text: this.$t("admin.actions"), value: "actions" },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.editedItem = { ...item.node };
      this.dialog = true;
    },
    editName(item) {
      this.editedItem = { ...item.node };
      this.editNameDialog = true;
    },
    reset() {
      this.editedItem = { userProfile: {} };
      this.dialog = false;
    },
    resetEditNameDialog() {
      this.editedItem = { userProfile: {} };
      this.editNameDialog = false;
    },
  },
};
</script>